// API client for the What's New + Ideas Board surfaces.
// Phase 2 — replaces the localStorage-backed mockup data with real endpoints.

import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// ── Releases ────────────────────────────────────────────────────────────
export async function fetchReleases() {
  const { data } = await axios.get(`${API}/whats-new/releases`);
  return data.releases || [];
}

export async function fetchUnreadCount() {
  try {
    const { data } = await axios.get(`${API}/whats-new/unread-count`);
    return { unread: data.unread || 0, total: data.total || 0 };
  } catch {
    return { unread: 0, total: 0 };
  }
}

export async function markReleaseViewed(releaseId) {
  await axios.post(`${API}/whats-new/releases/${releaseId}/view`);
}

export async function createRelease(payload) {
  const { data } = await axios.post(`${API}/admin/whats-new/releases`, payload);
  return data;
}

export async function updateRelease(id, payload) {
  const { data } = await axios.patch(`${API}/admin/whats-new/releases/${id}`, payload);
  return data;
}

export async function deleteRelease(id) {
  await axios.delete(`${API}/admin/whats-new/releases/${id}`);
}

// ── Ideas ───────────────────────────────────────────────────────────────
export async function fetchIdeas({ status = "all", sort = "top", includePending = false } = {}) {
  const params = new URLSearchParams();
  if (status && status !== "all") params.set("status", status);
  params.set("sort", sort);
  if (includePending) params.set("include_pending", "true");
  const { data } = await axios.get(`${API}/feedback/ideas?${params.toString()}`);
  return data.ideas || [];
}

export async function createIdea(payload) {
  const { data } = await axios.post(`${API}/feedback/ideas`, payload);
  return data;
}

export async function voteIdea(id) {
  const { data } = await axios.post(`${API}/feedback/ideas/${id}/vote`);
  return data;
}

export async function unvoteIdea(id) {
  const { data } = await axios.delete(`${API}/feedback/ideas/${id}/vote`);
  return data;
}

export async function adminUpdateIdea(id, payload) {
  const { data } = await axios.patch(`${API}/admin/feedback/ideas/${id}`, payload);
  return data;
}

export async function adminDeleteIdea(id) {
  await axios.delete(`${API}/admin/feedback/ideas/${id}`);
}
